import {
  SCAN_APP_STORE_LINK,
  SCAN_GOOGLE_PLAY_LINK,
  SCAN_ANDROID_INTENT_LINK_PREFIX,
  SCAN_ANDROID_INTENT_LINK_SUFFIX,
  SCAN_IOS_URL_SCHEME,
} from '@constants/scan';

import { getOS } from '@utils/get_os';

export const SDK_INTEGRATIONS = ['APPLE', 'SAMSUNG'];

export const getScanAppLink = (email?: string | null) => {
  const os = getOS();
  switch (os) {
    case 'Mac OS':
      return SCAN_APP_STORE_LINK;
    case 'iOS':
    case 'iPadOS':
      // com.vitallhealth.scan://scan?username="myUsername"'
      return `${SCAN_IOS_URL_SCHEME}${email ? `?username="${email}"` : ''}`;
    case 'Android':
      // intent://scan#Intent;scheme=com.vitallhealth.scan;S.username=myUsername;end
      return `${SCAN_ANDROID_INTENT_LINK_PREFIX}${
        email ? `;S.username=${email}` : ''
      }${SCAN_ANDROID_INTENT_LINK_SUFFIX}`;
    case 'Windows':
    case 'Linux':
      return SCAN_GOOGLE_PLAY_LINK;
    default:
      return null;
  }
};

/**
 * Redirects user to scan app if on mobile/tablet
 * Renders a QR code if user is on desktop
 * @param link Scan app link
 * @param openModal Function that opens modal containing QR code
 */
export const handleRenderQrCode = (link: string, openModal: () => void) => {
  const os = getOS();
  if (os === 'Mac OS' || os === 'Windows' || os === 'Linux') {
    openModal();
  } else if (os === 'iOS' || os === 'iPadOS') {
    open(SCAN_APP_STORE_LINK, '_blank');
    /*
    setTimeout(() => {
      open(SCAN_APP_STORE_LINK, '_blank');
    }, 2500);
    open(link, '_blank');
    */
  } else {
    open(link, '_blank');
  }
};
